export default "__VITE_ASSET__BRn$LkdQ__"